const AUTH_ROUTES = {
  confirm: '/auth/confirmation',
  login: '/auth/sign_in.json',
  logout: '/auth/sign_out',
  request_password: '/auth/password',
  reset_password: '/auth/password',
  validate_token: '/'
}

const BUSINESSES_ROUTES = {
  index: '/businesses',
  create: '/businesses/',
  get: '/businesses/:id',
  update: '/businesses/:id',
  select: '/businesses/select',
  activate: '/businesses/:id/activate',
  deactivate: '/businesses/:id/deactivate',
}

const BUSERS_ROUTES = {
  index: '/busers',
  create: '/busers/',
  get: '/busers/:id',
  update: '/busers/:id',
  // activate: '/busers/:id/activate',
  // deactivate: '/busers/:id/deactivate',
}

const COMPETENCIES_ROUTES = {
  index: '/competencies',
  get: '/competencies/:id',
  update: '/competencies/:id',
  create: '/competencies',
}

const COUPONS_ROUTES = {
  index: '/coupons',
  create: '/coupons/',
  destroy: '/coupons/:id',
  get: '/coupons/:id',
  update: '/coupons/:id',
  select: '/coupons/select',
  publish: '/coupons/:id/publish',
  unpublish: '/coupons/:id/unpublish',
  revoke: '/coupons/:id/revoke',
  reset_token: '/coupons/:id/reset_token',
}

const FEEDBACK_ROUTES = {
  index: '/feedback',
  get: '/feedback/:id',
  get_feedback_by_position: '/feedback/skip',
  get_questions: '/feedback/questions',
  mark_read: '/feedback/:id/mark_read',
  mark_unread: '/feedback/:id/mark_unread',
  mark_resolved: '/feedback/:id/mark_resolved',
}

const GRAPH_ROUTES = {
  get: '/graphs'
}

const PAYMENTS_ROUTES = {
  index: '/payments',
  get: '/payments/:id',
  get_payment_by_position: '/payments/skip',
  receipt: '/payments/:id/receipt',
  send_receipt: '/payments/:id/send_receipt',
}

const PREFERENCES_ROUTES = {
  index: '/preferences',
  update: '/preferences'
}

const PROSPECTS_ROUTES = {
  index: '/prospects',
  destroy: '/prospects/:id',
  resend: '/prospects/:id/resend',
}

const BUSINESS_PROSPECTS_ROUTES = {
  index: '/business_prospects',
  destroy: '/business_prospects/:id',
  resend: '/business_prospects/:id/resend',
}

const QUESTIONS_ROUTES = {
  index: '/questions',
  get: '/questions/:id',
  get_question_by_position: '/questions/skip',
  levels_per_tag_and_skill: '/questions/levels_per_tag_and_skill',
  update: '/questions/:id',
  create: '/questions',
  destroy: '/questions/:id',
  duplicate: '/questions/:id/duplicate',
  publish: '/questions/:id/publish',
  unpublish: '/questions/:id/unpublish',
  trash: '/questions/:id/trash',
  upload_audio: '/questions/upload_audio',
  audio: '/questions/:id/audio',
  upload_image: '/questions/upload_image',
  image: '/questions/:id/image'
}

const SKILLS_ROUTES = {
  index: '/skills',
  get: '/skills/:id',
  update: '/skills/:id',
  create: '/skills',
  publish: '/skills/:id/publish',
  unpublish: '/skills/:id/unpublish'
}

const TAGS_ROUTES = {
  index: '/tags',
  get: '/tags/:id',
  update: '/tags/:id',
  create: '/tags',
  // publish: '/tags/:id/publish',
  // unpublish: '/tags/:id/unpublish'
}

const TEMPLATES_ROUTES = {
  index: '/templates',
  get: '/templates/:id',
  update: '/templates/:id',
  create: '/templates',
  destroy: '/templates/:id',
  select: '/templates/select',
  publish: '/templates/:id/publish',
  unpublish: '/templates/:id/unpublish',
  trash: '/templates/:id/trash',
}

const TESTS_ROUTES = {
  index: '/tests',
  get_test_by_position: '/tests/skip',
  get: '/tests/:id/report',
}

const USERS_ROUTES = {
  index: '/users',
  get: '/users/:id',
  update: '/users/:id',
  create: '/users',
  select: '/users/select',
  // destroy: '/users/:id',
  lock: '/users/:id/lock',
  unlock: '/users/:id/unlock',
  resend: '/users/:id/reconfirm',
  change_password: '/users/:id/change_password'
}

const VOUCHERS_ROUTES = {
  index: '/vouchers',
  create: '/vouchers/',
  destroy: '/vouchers/:id',
  get: '/vouchers/:id',
  update: '/vouchers/:id',
  activate: '/vouchers/:id/activate',
  revoke: '/vouchers/:id/revoke',
  resend: '/vouchers/:id/resend',
  autofill: '/vouchers/autofill'
}


export {
  AUTH_ROUTES,
  BUSINESSES_ROUTES,
  BUSERS_ROUTES,
  COMPETENCIES_ROUTES,
  COUPONS_ROUTES,
  FEEDBACK_ROUTES,
  GRAPH_ROUTES,
  PAYMENTS_ROUTES,
  PREFERENCES_ROUTES,
  PROSPECTS_ROUTES,
  BUSINESS_PROSPECTS_ROUTES,
  QUESTIONS_ROUTES,
  SKILLS_ROUTES,
  TESTS_ROUTES,
  TAGS_ROUTES,
  TEMPLATES_ROUTES,
  USERS_ROUTES,
  VOUCHERS_ROUTES,
}



// WEBPACK FOOTER //
// ./src/js/constants/_routes.js